<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="buttonTabs"></ng-container>
            <tt-button-goto ttText="new_campaign" ttGoto="campaignedit" [ttGotoParms]="{ campaign_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListCampaigns"></tt-list>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="campaigns_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="buttonTabs"></ng-container>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="itemsListCampaigns"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <tt-button-goto ttText="new_campaign" ttGoto="campaignedit" [ttGotoParms]="{ campaign_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #buttonTabs>
    <ng-container *ngIf="!!page">
        <tt-tabs ttRememberId="campaigns:selected" [(ttSelectedId)]="page.campaign_selected" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="campaigns_active" ttLabel="campaigns_active"></tt-tab>
            <tt-tab ttId="campaigns_scheduled" ttLabel="campaigns_scheduled"></tt-tab>
            <tt-tab ttId="campaigns_finished" ttLabel="campaigns_finished"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>
